import Editor, { EditorProps, useMonaco } from '@monaco-editor/react';
import { Spin } from 'antd';
import { FC, memo } from 'react';
import { Spinner } from '../Spinner/Spinner';
import { CodeEditorLanguage } from './CodeEditor.interface';
import { CodeEditorToolbar } from './CodeEditorToolbar';

interface Props {
  value?: EditorProps['value'];
  disabled?: boolean;
  loading?: boolean;
  language?: CodeEditorLanguage;
  readOnly?: NonNullable<EditorProps['options']>['readOnly'];
  height?: EditorProps['height'];
  disableMinimap?: boolean;
  onChange?: EditorProps['onChange'];
}

export const CodeEditor: FC<Props> = memo(
  ({
    value,
    onChange,
    disabled = false,
    readOnly = false,
    language = CodeEditorLanguage.Handlebars,
    height = '650px',
    loading = false,
    disableMinimap = false
  }) => {
    const monacoEditor = useMonaco();

    return monacoEditor ? (
      <Spin spinning={ loading || disabled } style={{ minHeight: 40 }}>
        <CodeEditorToolbar fileContent={ value || '' } disabled={ disabled }/>

        <Editor
          // onMount={ (editor, monaco) => {
          //   monaco.editor.setModelMarkers(editor.getModel()!, '', [
          //     {
          //       startLineNumber: 10,
          //       startColumn: 4,
          //       endLineNumber: 10,
          //       endColumn: 9,
          //       message: 'test m',
          //       severity: monaco.MarkerSeverity.Error,
          //       code: 'test c',
          //       source: 'test s'

          //     }
          //   ]);
          // } }
          value={ value || '' }
          onChange={ onChange }
          height={ height }
          theme="vs-dark"
          language={ language }
          loading
          options={{
            renderWhitespace: 'all',
            readOnly,
            tabCompletion: 'on',
            'semanticHighlighting.enabled': true,
            contextmenu: true,
            cursorBlinking: 'smooth',
            columnSelection: false,
            gotoLocation: {
              multiple: 'goto',
              multipleDefinitions: 'goto',
              multipleDeclarations: 'goto',
              multipleImplementations: 'goto',
              multipleReferences: 'goto',
              multipleTypeDefinitions: 'goto'
            },
            parameterHints: {
              enabled: true
            },
            minimap: {
              enabled: !disableMinimap,
              showSlider: 'always',
              size: 'fit',
              scale: 2
            },
            selectOnLineNumbers: true,
            roundedSelection: true,
            smartSelect: { selectLeadingAndTrailingWhitespace: true, selectSubwords: true },
            fontSize: 12,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
            cursorStyle: 'line',
            codeLens: true,
            autoClosingBrackets: 'always',
            autoClosingQuotes: 'always',
            autoIndent: 'full',
            autoSurround: 'languageDefined',
            formatOnPaste: true,
            formatOnType: true,
            wordWrap: 'on',
            smoothScrolling: true
          }}
        />
      </Spin>
    ) : (
      <Spinner/>
    );
  }
);
